/* KP custom: lazy-loading tabs for kp-featured-products.
   Tabs after the first render empty; when a tab is clicked its products
   are fetched from /collections/<handle>?view=kp-cards and injected. */
(function () {
  function fillLazySwiper(swiperEl) {
    if (!swiperEl || swiperEl.dataset.kpLazyLoaded === 'true' || swiperEl.dataset.kpLazyLoading === 'true') return;
    const url = swiperEl.dataset.kpLazyUrl;
    if (!url) return;

    swiperEl.dataset.kpLazyLoading = 'true';
    const limit = parseInt(swiperEl.dataset.kpLimit || '12', 10);

    fetch(url)
      .then(r => (r.ok ? r.text() : Promise.reject(r.status)))
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const cards = [...doc.querySelectorAll('.kp-lazy-card')].slice(0, limit);
        const wrapper = swiperEl.querySelector('.swiper-wrapper');
        if (!wrapper || cards.length === 0) return;

        cards.forEach(card => {
          const slide = document.createElement('div');
          slide.classList.add('swiper-slide', 'card-product-slider__slide');
          while (card.firstChild) slide.appendChild(card.firstChild);
          wrapper.appendChild(slide);
        });

        swiperEl.dataset.kpLazyLoaded = 'true';

        // The swiper may have initialized while the tab was hidden/empty.
        if (swiperEl.swiper) {
          swiperEl.swiper.update();
          if (swiperEl.swiper.navigation) swiperEl.swiper.navigation.update();
        } else if (typeof swiperEl.init === 'function') {
          swiperEl.init();
        }

        if (document.querySelector('quick-cart-drawer')) {
          document.querySelector('quick-cart-drawer').init();
        }
      })
      .catch(() => {})
      .finally(() => {
        delete swiperEl.dataset.kpLazyLoading;
      });
  }

  document.addEventListener('click', event => {
    const tabButton = event.target.closest('[class*="products-feed__tablinks--"]');
    if (!tabButton) return;
    const onclickAttr = tabButton.getAttribute('onclick') || '';
    const match = onclickAttr.match(/'([^']+)'\s*\)\s*$/);
    if (!match) return;
    const blockId = match[1];
    const tabContent = document.getElementById(blockId);
    if (!tabContent) return;
    fillLazySwiper(tabContent.querySelector('[data-kp-lazy-url]'));
  });
})();
